// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header */
#team-container .brand-name a,
#team-container a.link {
  color: #464646;
}

#team-container a.link:hover {
  color: #949494;
}

#team-container img {
  color: blue;
}

/* team */
#team {
  position: relative;
  top: 12vh;
  border-top: 1px solid #808080;
  margin-bottom: 12vh;
}

#team .intro {
  padding: 2% 6%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#team .intro .title {
  color: #464646;
  font-family: 'Cinzel', serif;
  font-size: 36px;
  margin-bottom: 45px;
  text-align: center;
}

#team .intro img.team-icon {
  height: 75px;
  margin-bottom: 60px;
}

#team .intro .info-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  width: 100%;
  flex-wrap: wrap;
}

#team .intro .info-container .member-container {
  width: 360px;
  margin: 20px 40px 30px 40px;
  align-items: center;
  display: flex;
  flex-direction: column;
}

#team .member-container .image-container {
  border-radius: 120px;
  width: 240px;
  height: 240px;
  overflow: hidden;
  margin-bottom: 20px;
}

#team .member-container .image-container img {
  width: 240px;
}

#team .member-container h3 {
  font-weight: 700;
  font-size: 18px;
}

#team .member-container h4 {
  font-size: 14px;
}

#team .member-container .link-container {
  width: 88px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-top: 5px;
  margin-bottom: 20px;
}

#team .member-container .link-container img {
  opacity: 0.8;
  cursor: pointer;
}

#team .member-container .link-container img:hover {
  opacity: 1;
}

#team .member-container .link-container .linkedin {
  height: 20px;
  width: auto;
}

#team .member-container .link-container .email {
  height: 16px;
  width: auto;
}

#team .member-container .link-container .telegram,  #team .member-container .link-container .telegram svg{
  height: 20px;
  width: auto;
}

#team .member-container p {
  font-size: 12px;
  margin-bottom: 20px;
  text-align: justify;
}
`, "",{"version":3,"sources":["webpack://./client/styles/Team.css"],"names":[],"mappings":"AAAA,WAAW;AACX;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,SAAS;EACT,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":["/* Header */\n#team-container .brand-name a,\n#team-container a.link {\n  color: #464646;\n}\n\n#team-container a.link:hover {\n  color: #949494;\n}\n\n#team-container img {\n  color: blue;\n}\n\n/* team */\n#team {\n  position: relative;\n  top: 12vh;\n  border-top: 1px solid #808080;\n  margin-bottom: 12vh;\n}\n\n#team .intro {\n  padding: 2% 6%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n#team .intro .title {\n  color: #464646;\n  font-family: 'Cinzel', serif;\n  font-size: 36px;\n  margin-bottom: 45px;\n  text-align: center;\n}\n\n#team .intro img.team-icon {\n  height: 75px;\n  margin-bottom: 60px;\n}\n\n#team .intro .info-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  text-align: center;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n#team .intro .info-container .member-container {\n  width: 360px;\n  margin: 20px 40px 30px 40px;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n}\n\n#team .member-container .image-container {\n  border-radius: 120px;\n  width: 240px;\n  height: 240px;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n#team .member-container .image-container img {\n  width: 240px;\n}\n\n#team .member-container h3 {\n  font-weight: 700;\n  font-size: 18px;\n}\n\n#team .member-container h4 {\n  font-size: 14px;\n}\n\n#team .member-container .link-container {\n  width: 88px;\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-top: 5px;\n  margin-bottom: 20px;\n}\n\n#team .member-container .link-container img {\n  opacity: 0.8;\n  cursor: pointer;\n}\n\n#team .member-container .link-container img:hover {\n  opacity: 1;\n}\n\n#team .member-container .link-container .linkedin {\n  height: 20px;\n  width: auto;\n}\n\n#team .member-container .link-container .email {\n  height: 16px;\n  width: auto;\n}\n\n#team .member-container .link-container .telegram,  #team .member-container .link-container .telegram svg{\n  height: 20px;\n  width: auto;\n}\n\n#team .member-container p {\n  font-size: 12px;\n  margin-bottom: 20px;\n  text-align: justify;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
